"use strict";

exports.__esModule = true;
var _UsersScreen = require("./UsersScreen");
Object.keys(_UsersScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UsersScreen[key]) return;
  exports[key] = _UsersScreen[key];
});